<template>
    <!-- edit mode -->
    <div
        class="slider-container"
    >
        <vue-slider
            ref="slider"
            v-model="value.Text"
            :data="getSlideTexts(options)"
            :piecewise="true"
            :disabled="loading"
            :lazy="true"
            @input="updateValue"
            @callback="$emit('change', true)"
        />
    </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import FormComponentMixin from './_FormComponentMixin';

export default {
    name: 'Slider',
    components: {
        vueSlider
    },
    mixins: [FormComponentMixin],
    props: {
        options: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        getSlideTexts(options) {
            return options.map((obj) => obj.Text);
        },
        updateValue() {
            const i = this.$refs.slider.getIndex();
            this.$emit('input', this.options[i]);
        }
    }
};
</script>

<style lang="scss">

.slider-container {
    margin-top: 1rem;
}

</style>
